import React, { useState, useRef } from 'react';
import {
  Row,
  Col,
  Container,
  CardBody,
  Button,
  Card,
  UncontrolledTooltip
} from 'reactstrap';
import { DataTable, Column, PreviewHTML } from 'vivace-fluent-motion';
import { Switch, FormControlLabel } from '@material-ui/core';
import * as actions from './store/materiais.action';
import * as commonActions from '@common/common.action';
import DescarteApi from '../../descarte.api';
import { useSelector, useDispatch } from 'react-redux';
import ComponentesDescarte from '../../common/components';
import { useReactToPrint } from 'react-to-print';
import Sepultamento from '../../common/components/Lote/Sepultamento';
import Padrao from '../../common/components/Lote/Padrao';
import SelectComponent from '@componentes/select/select.component';
import * as DefautValues from '@common/util/defaultValues';
import CommonFunctions from '@util/functions.common';
import ModalDetalhesLote from '../../modais/detalhes';
import IntlMessage from '../../../../helpers/intlMessage';
import { useIntl } from 'react-intl';

const options = [
  { value: 'dtdescarte', label: <IntlMessage id = "dashboards.disposalMaterials.disposalDate"/>},
  { value: 'descricao', label: <IntlMessage id = "dashboards.disposalMaterials.lotDescription"/>},
  { value: 'items', label: <IntlMessage id = "dashboards.disposalMaterials.items"/>},
  { value: 'nrExame', label: <IntlMessage id = "dashboards.disposalMaterials.examNumber"/>},
  { value: 'peso', label: <IntlMessage id = "dashboards.disposalMaterials.totalWeight"/>},
  { value: 'usuario', label: <IntlMessage id = "dashboards.disposalMaterials.user"/>}
];

export default function Materiais () {
  const [selectFilter, setSelectFilter] = useState('');
  const [listLote, setListLote] = useState([]);
  const [selectGrid, setSelectGrid] = useState(0);
  const [search, setSearch] = useState(false);
  const [totalItensPage] = useState(20);
  const [previewHTML, setPreviewHTML] = useState(false);
  const [modalFiltros, setModalFiltros] = useState(false);
  const [sortName, setSortName] = useState('dataDescarte');
  const [ascending, setAscending] = useState(1);
  const [totalItens, setTotalItens] = useState(0);
  const [listaImpressao, setListaImpressao] = useState([]);
  const [isEspecial, setIsEspecial] = useState(false);
  const [isSepultamento, setIsSepultamento] = useState(false);
  const [showModalDetalhesLote, setShowModalDetalhesLote] = useState(false);
  const [idDetalhes, setIdDetalhes] = useState();

  const intl = useIntl();

	function translate(key) {
	  return intl.formatMessage({ id: key });
	}

  const componentRef = useRef();
  const lista = useSelector(state => state.materiaisDescartados.lista);
  const dataInicio = useSelector(
    state => state.materiaisDescartados.dataInicio
  );
  const dataFim = useSelector(state => state.materiaisDescartados.dataFim);
  const filtroValue = useSelector(
    state => state.materiaisDescartados.filtroValue
  );
  const carregando = useSelector(state => state.commonReducer.showCarregando);
  const numPagina = useSelector(state => state.materiaisDescartados.page);
  const permissao = useSelector(
    state => state.descarteCommon.permissaoDescarteMateriais
  );
  const dadosGeraisHospital = useSelector(
    state => state.commonReducer.dadosGeraisHospital
  );

  const dispatch = useDispatch();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: dadosGeraisHospital.razaosoc
  });

  function buscarDadosImpressao () {
    dispatch(commonActions.showFadeCarregando(true));
    const filtroTipo = isSepultamento
      ? DefautValues.tipoDescarteEmum.SEPULTAMENTO
      : DefautValues.tipoDescarteEmum.PADRAO;

    DescarteApi.listarLote(
      selectFilter,
      filtroValue,
      dataInicio,
      dataFim,
      1,
      totalItens,
      filtroTipo,
      sortName,
      ascending
    )
      .then(res => {
        if (res.data.length > 0) {
          setListaImpressao(res.data);
          setPreviewHTML(true);
        }
        dispatch(commonActions.showFadeCarregando(false));
      })
      .catch(() => dispatch(commonActions.showFadeCarregando(false)));
  }

  function showMessageByResults (results) {
    if (results > 0) {
      /* const plural = results > 1 ? 's' : ''; */
      const mensagem = <IntlMessage id = "dashboards.disposalMaterials.dataSucessfully"/>
      dispatch(commonActions.showAlerta('sucesso', mensagem, 10));
    } else {
      dispatch(
        commonActions.showAlerta('alerta', <IntlMessage id = "dashboards.disposalMaterials.noResult"/>, 3000)
      );
    }
  }

  function changeFilter (e) {
    setSelectFilter(e.value);
    dispatch(actions.dataInicio(dataInicio));
    dispatch(actions.dataFim(dataFim));
    dispatch(actions.filtroValue(''));
  }

  function changeSepultamento (el) {
    setIsSepultamento(el);
    if (el) {
      setIsEspecial(!el);
    }
    buscar(false, false, { sepultamento: el, especial: false });
  }

  function changeEspecial (el) {
    setIsEspecial(el);
    if (el) {
      setIsSepultamento(!el);
    }
    buscar(false, false, { sepultamento: false, especial: el });
  }

  function showModalFiltros () {
    setModalFiltros(!modalFiltros);
  }

  function ComponentHTML ({ id }) {
    return (
      <div className='mv-visualizador-html'>
        <Card id={id}>
          <CardBody>
            <Container fluid>
              <div ref={componentRef}>
                {!isSepultamento && <Padrao lista={listaImpressao} />}
                {isSepultamento && <Sepultamento lista={listaImpressao} />}
              </div>
            </Container>
          </CardBody>
        </Card>
      </div>
    );
  }

  function toggle (checked) {
    let checkboxes = document.getElementsByClassName('checkbox');
    for (let i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i] !== checked) {
        checkboxes[i].checked = checked;
        if (checked) {
          setSelectGrid(checkboxes.length);
          document
            .getElementsByClassName('container-fluid')[1]
            .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'true');
        } else {
          setSelectGrid(0);
          document
            .getElementsByClassName('container-fluid')[1]
            .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'false');
        }
      }
    }
  }

  function RenderizarFooter ({ total }) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItens: 'center'
        }}
      >
        <span
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItens: 'center'
          }}
        >
          <i
            className='mv-basico-stacktrace'
            style={{ fontSize: '20px', height: '18px' }}
          />{' '}
          <span style={{ marginTop: '2px' }}>
            <IntlMessage id = "dashboards.disposalMaterials.table.materialsTotalDiscard"/> {total}
          </span>
        </span>
      </div>
    );
  }

  function restaurarItens () {
    dispatch(commonActions.showFadeCarregando(true));
    let items = [];
    const novalista = [...listLote];
    let checkboxes = document.querySelectorAll('input[name=checkbox]');
    //let checkboxesAll = document.querySelectorAll('input[name=checkbox]');
    for (let i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].checked) {
        items.push({ idLote: checkboxes[i].id });
      }
    }

    items.forEach(element => {
      novalista.map((l, i) => {
        if (Number(l.id) === Number(element.idLote)) {
          document
            .getElementById(`${element.idLote}`)
            .parentElement.parentElement.setAttribute('datacheck', 'false');
          novalista.splice(i, 1);
        }
        return novalista;
      });
    });

    toggle(false);
    dispatch(commonActions.showFadeCarregando(true));
    DescarteApi.restaurar(items)
      .then(res => {
        dispatch(commonActions.showAlerta('sucesso', res.message, 3000));
        dispatch(actions.lista(novalista));
        setListLote(novalista);
        setSelectGrid(0);
        setTotalItens(novalista.length);
        dispatch(commonActions.showFadeCarregando(false));
      })
      .catch(err => {
        dispatch(commonActions.showAlerta('erro', err.message, 3000));
        dispatch(commonActions.showFadeCarregando(false));
      });
  }

  function selectItem (e) {
    let tr = document.getElementsByTagName('tr');
    let checkboxes = document.querySelectorAll('input[name=checkbox]:checked');
    setSelectGrid(checkboxes.length);
    if (checkboxes.length === 0) {
      document.getElementById('select').checked = false;
    }
    for (let i = 0; i < tr.length - 1; i++) {
      if (
        document.getElementsByTagName('tr')[i + 1].getElementsByTagName('td')
          .length > 0 &&
        document
          .getElementsByTagName('tr')[i + 1].getElementsByTagName('td')[0]
          .getElementsByTagName('input')[0]
      ) {
        if (
          document
            .getElementsByTagName('tr')[i + 1].getElementsByTagName('td')[0]
            .getElementsByTagName('input')[0].id === e.target.id
        ) {
          if (
            document
              .getElementsByTagName('tr')[i + 1].getAttribute('datacheck') === 'true'
          ) {
            document
              .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'false');
          } else {
            document
              .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'true');
          }
        }
      }
    }
  }

  function onChangeSelect (e) {
    let tr = document.getElementsByTagName('tr');
    for (let i = 0; i < tr.length - 1; i++) {
      if (
        document.getElementsByTagName('tr')[i + 1].getElementsByTagName('td')
          .length > 0 &&
        document
          .getElementsByTagName('tr')[i + 1].getElementsByTagName('td')[0]
          .getElementsByTagName('input')[0]
      ) {
        if (
          document
            .getElementsByTagName('tr')[i + 1].getElementsByTagName('td')[0]
            .getElementsByTagName('input')[0].id === e.data.id.toString()
        ) {
          if (
            document
              .getElementsByTagName('tr')[i + 1].getAttribute('datacheck') === 'true'
          ) {
            document
              .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'false');
            document.getElementById(e.data.id.toString()).checked = false;
          } else {
            document
              .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'true');
            document.getElementById(e.data.id.toString()).checked = true;
          }
        }
      }
    }
    let checkboxes = document.querySelectorAll('input[name=checkbox]:checked');
    setSelectGrid(checkboxes.length);
  }

  function Tootip ({ id, text, length }) {
    return (
      <span id={`obs_${id}`}>
        {`${text.slice(0, length)}...`}
        <UncontrolledTooltip placement='top' target={`obs_${id}`}>
          {text}
        </UncontrolledTooltip>
      </span>
    );
  }

  function selectInfo (id) {
    setIdDetalhes(id);
    setShowModalDetalhesLote(true);
  }

  function insertSelectLote (dados) {
    const lista = [];
    dados.map(item => {
      return lista.push({
        id: item.idLote,
        items: item.items,
        usuario: item.usuarioLiberacao,
        descricao: item.descricaoLote,
        exame:
          item.exames && item.exames.length > 16 ? (
            <Tootip
              id={`exames_${item.idLote}`}
              text={item.exames}
              length={16}
            />
          ) : (
            item.exames
          ),
        info: (
          <div className='botao-editar'>
            {item.observacao}{' '}
            <input onClick={e => selectInfo(item.idLote)} type='button' />
            <i className='mv-basico-zoom_in'></i>
          </div>
        ),
        obs:
          item.obs && item.obs.length > 30 ? (
            <Tootip id={item.idLote} text={item.obs} length={30} />
          ) : (
            item.obs
          ),
        dataDescarte: CommonFunctions.formatData(item.dataDescarte),
        peso: <span id={`peso_${item.pesoTotal}`}>{item.pesoTotal}</span>,
        tipo: item.tipoDescarte === 2 ? 'Sepultamento' : 'Padrão',
        select: (
          <input
            className='checkbox'
            name='checkbox'
            type='checkbox'
            id={item.idLote}
            onClick={e => selectItem(e)}
          />
        )
      });
    });

    setListLote(lista);
  }

  function onSort (event) {
    //let orderAsc = event.sortOrder === 1;
    let field = event.sortField;
    setAscending(event.sortOrder);
    setSortName(field);
    dispatch(actions.page(1));
    lista.length > 0 && buscar(field, event.sortOrder);
  }

  function atualizarPagina (page) {
    buscar(null, null, null, page);
  }

  function buscar (field, order, tipo, nPage) {
    let DataInicio, DataFim, FiltroValue, FiltroTipo, SortName, SortAsc, Pagina;

    Pagina = numPagina;
    FiltroTipo = isSepultamento
      ? DefautValues.tipoDescarteEmum.SEPULTAMENTO
      : DefautValues.tipoDescarteEmum.PADRAO;

    if (tipo) {
      FiltroTipo = tipo.sepultamento
        ? DefautValues.tipoDescarteEmum.SEPULTAMENTO
        : tipo.especial
        ? DefautValues.tipoDescarteEmum.ESPECIAL
        : DefautValues.tipoDescarteEmum.PADRAO;
    }
    if (nPage) {
      Pagina = nPage;
    } else {
      dispatch(actions.page(1));
      Pagina = 1;
    }

    if (field) {
      SortName = field;
      SortAsc = order;
    } else if (sortName) {
      SortName = sortName;
      SortAsc = ascending;
    }
    if (selectFilter.indexOf('dt') >= 0) {
      DataInicio = dataInicio;
      DataFim = dataFim;
    } else {
      FiltroValue = filtroValue;
    }

    let executarValidacaoDeData = (selectFilter.indexOf('dt') >= 0);
    let result = {valid: true, message: ''};

    if (executarValidacaoDeData)
      result = CommonFunctions.validaData(DataInicio, DataFim, intl, commonActions);

    if (!result.valid) {
      dispatch(commonActions.showAlerta('alerta', result.message, 3000));
      return;
    }

    dispatch(commonActions.showFadeCarregando(true));

    DescarteApi.listarLote(
      selectFilter,
      FiltroValue,
      DataInicio,
      DataFim,
      Pagina,
      totalItensPage,
      FiltroTipo,
      SortName,
      SortAsc
    )
      .then(res => {
        setSearch(true);
        setTotalItens(res.totalItems);
        showMessageByResults(res.totalItems);
        dispatch(actions.lista(res.data));
        insertSelectLote(res.data);
        dispatch(commonActions.showFadeCarregando(false));
      })
      .catch(err => {
        console.log(err);
        dispatch(commonActions.showFadeCarregando(false));
        showMessageByResults(0);
      });
  }

  return (
    <React.Fragment>
      <ModalDetalhesLote
        onModal={() => {
          setShowModalDetalhesLote(!showModalDetalhesLote);
        }}
        showModalDescarte={showModalDetalhesLote}
        confirmar={() => buscar(false, false)}
        id={idDetalhes}
        tipo={
          isSepultamento ? 'de sepultamento' : isEspecial ? 'especial' : null
        }
      />

      <div className='mv-descarte-tab materiais'>
        <PreviewHTML
          messageTitle = {<IntlMessage id = "dashboards.reports.printPreview"/>} 
          printLabel = {<IntlMessage id = "dashboards.reports.printOut"/>}
          visible={previewHTML}
          id='uniqueID'
          component={<ComponentHTML id='uniqueID' />}
          onOpened={e => setPreviewHTML(e)}
          onPrint={handlePrint}
        />
        <Row>
          <Col>
            <Card>
              <CardBody>
                <Row>
                  <Col xs={3} style={{ maxWidth: 240 }}>
                    <SelectComponent
                      options={options}
                      placeholder={translate("dashboards.disposalMaterials.chooseOne")}
                      defaultValue={selectFilter}
                      onChange={e => changeFilter(e)}
                    />
                  </Col>
                  {selectFilter && (
                    <div className='col-auto'>
                      {selectFilter && (
                        <ComponentesDescarte
                          component={selectFilter}
                          onPressEnter={buscar}
                        />
                      )}
                    </div>
                  )}
                  <Col xs={4}>
                    <Button
                      style={{ height: '38px', width: '38px'}}
                      className='btn btn-primary'
                      disabled={!selectFilter}
                      onClick={() => buscar()}
                    >
                      <i className='icons-btn mv-basico-pesquisar'></i>
                    </Button>
                    {search && listLote.length > 0 && (
                      <Button
                        className='btn btn-descarte btn-info'
                        onClick={() => restaurarItens()}
                        disabled={!selectGrid}
                      >
                        {(listLote.length > 0 &&
                          permissao &&
                          selectGrid === totalItensPage) ||
                        (listLote.length > 0 &&
                          selectGrid === listLote.length &&
                          selectGrid > 1) ? (
                          <React.Fragment>
                            <i className='icons-btn mv-basico-retornar_situacao'></i>{' '}
                            <IntlMessage id = "dashboards.disposalMaterials.restoreAll"/>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <i className='icons-btn mv-basico-retornar_situacaor'></i>{' '}
                            <IntlMessage id = "dashboards.disposalMaterials.restore"/>
                          </React.Fragment>
                        )}
                      </Button>
                    )}
                  </Col>
                  {listLote.length > 0 && search && (
                    <Col>
                      <Button
                        className='btn btn-imprimir btn-success'
                        onClick={buscarDadosImpressao}
                        disabled={!search}
                      >
                        <i className='icons-btn mv-basico-imprimir'></i>{' '}
                        <IntlMessage id = "dashboards.disposalMaterials.printOut"/>
                      </Button>
                    </Col>
                  )}
                </Row>
              </CardBody>
            </Card>

            {search && !carregando && (
              <div className='mv-container-filtros'>
                <div className='mv-filtros' onClick={() => showModalFiltros()}>
                  <IntlMessage id = "dashboards.disposalMaterials.filters"/>
                </div>
              </div>
            )}

            {modalFiltros && (
              <div className='mv-modal-filtros'>
                <div
                  className='mv-modal-filtros-header'
                  onClick={() => showModalFiltros()}
                >
                  <IntlMessage id = "dashboards.disposalMaterials.filters"/>
                </div>
                <div className='mv-modal-filtros-body'>
                  {/* filtroValue !== 'dtvencimento' && */}
                  <FormControlLabel
                    control={
                      <Switch
                        checked={isEspecial}
                        onChange={e => changeEspecial(e.target.checked)}
                        name='descarte-especial'
                        color='primary'
                      />
                    }
                    label={<IntlMessage id = "dashboards.disposalMaterials.specialDisposal"/>}
                  />
                  {}
                  <FormControlLabel
                    control={
                      <Switch
                        checked={isSepultamento}
                        onChange={e => changeSepultamento(e.target.checked)}
                        name='descarte-sepultamento'
                        color='primary'
                      />
                    }
                    label={<IntlMessage id = "dashboards.disposalMaterials.burial"/>}
                  />
                </div>
              </div>
            )}
            {search && (
              <Card>
                <CardBody>
                  <Container fluid>
                    <DataTable
                      onSort={onSort}
                      sortField={sortName}
                      sortOrder={ascending}
                      onContextMenu={e => onChangeSelect(e)}
                      value={listLote}
                      //pageLinkSize={20}
                      responsive={true}
                      selectionMode='single'
                      style={{ height: '100%' }}
                      columnResizeMode='expand'
                      scrollable={true}
                      //scrollHeight="50vh"
                      scrollWidth='100%'
                      resizableColumns={listLote.length >= 1}
                      reorderableColumns={listLote.length >= 1}
                      first={(numPagina - 1) * totalItensPage}
                      //rowsPerPageOptions={[10, 20, 50]}
                      rows={totalItensPage}
                      lazy={true}
                      paginator={listLote.length > 0}
                      //loading={carregando}
                      //loadingIcon="mv-basico-menu_secundario"
                      emptyMessage={<IntlMessage id = "dashboards.disposalMaterials.noResult"/>}
                      alwaysShowPaginator={false}
                      autoLayout={true}
                      totalRecords={totalItens}
                      onPage={event => {
                        dispatch(actions.page(event.page + 1));
                        atualizarPagina(event.page + 1);
                      }}
                      footer={<RenderizarFooter total={totalItens} />}
                    >
                      <Column
                        sortable={false}
                        field='select'
                        style={{ width: '25px' }}
                        header={
                          listLote.length >= 1 && (
                            <input
                              type='checkbox'
                              id='select'
                              name='select'
                              onChange={e => {
                                toggle(e.target.checked);
                              }}
                            />
                          )
                        }
                      />

                      <Column
                        sortable={false}
                        field='info'
                        style={{ width: '50px' }}
                        header=''
                      />
                      <Column
                        sortable={listLote.length > 1}
                        field='items'
                        style={{ width: '100px' }}
                        header={<IntlMessage id = "dashboards.disposalMaterials.table.items"/>}
                      />
                      <Column
                        sortable={listLote.length > 1}
                        field='exame'
                        style={{ width: '150px' }}
                        header={<IntlMessage id = "dashboards.disposalMaterials.table.exams"/>}
                      />

                      <Column
                        sortable={listLote.length > 1}
                        field='usuario'
                        style={{ width: '250px' }}
                        header={<IntlMessage id = "dashboards.disposalMaterials.table.user"/>}
                      />
                      <Column
                        sortable={listLote.length > 1}
                        field='obs'
                        style={{ width: '250px' }}
                        header={<IntlMessage id = "dashboards.disposalMaterials.table.observationDiscard"/>}
                      />
                      <Column
                        sortable={listLote.length > 1}
                        field='descricao'
                        style={{ width: '250px' }}
                        header={<IntlMessage id = "dashboards.disposalMaterials.table.descriptionLot"/>}
                      />
                      <Column
                        sortable={listLote.length > 1}
                        field='dataDescarte'
                        style={{ width: '250px' }}
                        header={<IntlMessage id = "dashboards.disposalMaterials.discardDate"/>}
                      />

                      <Column
                        sortable={listLote.length > 1}
                        field='peso'
                        style={{ width: '250px' }}
                        header={<IntlMessage id = "dashboards.disposalMaterials.modal.weightG"/>}
                      />
                    </DataTable>
                  </Container>
                </CardBody>
              </Card>
            )}
          </Col>
        </Row>
        {!search && (
          <div className='icone-semdados'>
            <i className='inicial-icons mv-basico-retornar_situacao'></i>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/pages/descarte/tabs/materiais/index.js